const countries = {
    "am-ET": "امهری",
    "ar-SA": "عربی",
    "be-BY": "بلاروسی",
    "bem-ZM": "بمبا",
    "bi-VU": "بیسلاما",
    "bn-IN": "بنگالی",
    "bo-CN": "تبتی",
    "br-FR": "برتون",
    "bs-BA": "بوسنیایی",
    "ca-ES": "کاتالانی",
    "cop-EG": "قبطی",
    "cs-CZ": "چک",
    "cy-GB": "ولزی",
    "da-DK": "دانمارکی",
    "dz-BT": "دزونگخا",
    "de-DE": "آلمانی",
    "dv-MV": "مالدیو",
    "el-GR": "یونانی",
    "en-GB": "انگلیسی",
    "es-ES": "اسپانیایی",
    "et-EE": "استونیایی",
    "eu-ES": "باسک",
    "fa-IR": "فارسی",
    "fi-FI": "فنلاندی",
    "fn-FNG": "فاناگالو",
    "fr-FR": "فرانسوی",
    "gl-ES": "گالیسیایی",
    "gu-IN": "گجراتی",
    "ha-NE": "هوسه",
    "he-IL": "عبری",
    "hi-IN": "هندی",
    "hr-HR": "کرواسی",
    "hu-HU": "مجارستانی",
    "id-ID": "اندونزیایی",
    "is-IS": "ایسلندی",
    "it-IT": "ایتالیایی",
    "ja-JP": "ژاپنی",
}

export default countries